module.exports = __webpack_public_path__ + "img/videoSpeed.fa4e3c3e.jpg";